import { useCallback, useEffect, useState } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/forum`;
export async function forumApi(path, options = {}) {
  const res = await fetch(`${API}${path}`, { credentials: 'include', ...options, headers: { 'Content-Type': 'application/json', ...options.headers } });
  const data = await res.json();
  if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Revisa los campos e inténtalo de nuevo.');
  return data;
}

export function useForumData(path) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(!!path);
  const [version, setVersion] = useState(0);
  const refresh = useCallback(() => setVersion((v) => v + 1), []);
  useEffect(() => {
    if (!path) { setData(null); setLoading(false); return; }
    let active = true;
    const controller = new AbortController();
    setLoading(true); setError('');
    forumApi(path, { signal: controller.signal }).then((d) => { if (active) setData(d); }).catch((e) => { if (active) setError(e.message); }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; controller.abort(); };
  }, [path, version]);
  return { data, error, loading, refresh };
}
